$(document).ready(function () {
    var $reviewsStripEl = $('.js-reviews-strip');

    if (!$reviewsStripEl.length) {
        return;
    }

    // Reviews strip - slow autoplay, one card at a time, infinite loop,
    // manual click-and-drag scrolling (draggable/swipe are on by default).
    // centerMode + centerPadding (a slice of the next/previous slide
    // showing in the padding either side) is the same "peeking carousel"
    // approach already used by the multisite slider and the news/insights
    // slider. centerPadding is a percentage (slick supports px or %) so
    // the peek scales proportionally at every screen size rather than
    // needing many pixel breakpoints.
    //
    // Wide desktop (>1100px) shows 3 full cards with centerMode splitting
    // the peek between the slide before and after them - 5 cards worth of
    // card on screen at once, with only the outer two clipped by the
    // panel's edges. Narrower desktop/tablet (899-1100px) drops to 2 full
    // cards, and mobile drops further to the single-centred-card version
    // (slidesToShow: 1) since even 2 full cards don't fit a phone screen.
    //
    // variableWidth (cards at a fixed CSS width rather than 100% of the
    // slide) was tried first, since it seemed like the more direct way to
    // get the "next card peeking in" look, but combined with infinite +
    // centerMode it produced a broken multi-thousand-pixel-wide slick
    // track (a known bad interaction between those three slick options) -
    // fixed-percentage centerPadding avoids that entirely.
    $reviewsStripEl.slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 700,
        cssEase: 'ease-in-out',
        arrows: false,
        dots: false,
        draggable: true,
        swipeToSlide: true,
        centerMode: true,
        centerPadding: '10%',
        slidesToShow: 3,
        slidesToScroll: 1,
        pauseOnHover: true,
        pauseOnFocus: true,
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 2,
                    centerPadding: '10%',
                }
            },
            {
                breakpoint: 899,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '8%',
                }
            }
        ]
    });

    // Once someone drags/swipes the strip themselves, stop autoplay so it
    // doesn't immediately fight their manual scroll position - same
    // interaction decision already used for the multisite slider.
    $reviewsStripEl.on('swipe touchEnd', function () {
        $(this).slick('slickPause');
    });

    // Read more / read less - swap the truncated quote for the full one
    // (see reviews-strip.twig; only rendered at all when the quote is over
    // the 240-character limit). It's an <a href="#">, not a <button>, so
    // the click needs preventDefault() or it'll jump the page to the top.
    $reviewsStripEl.on('click', '.js-reviews-strip-read-more', function (e) {
        e.preventDefault();

        var $link = $(this);
        var $card = $link.closest('.reviews-strip__card');

        $card.find('.reviews-strip__quote-short, .reviews-strip__quote-full').toggle();
        $link.text($link.text() === 'Read more' ? 'Read less' : 'Read more');
    });
});
